import { connect } from 'react-redux';
import NetworkMembershipActions from 'reducers/networkMembership';
import PartnerOffersActions from 'reducers/partnerOffers';
import PaymentMethodsActions from 'reducers/paymentMethods';
import SearchParamsActions from 'reducers/searchParams';
import TrackingActions from 'reducers/tracking';

const mapStateToProps = ({
  networkMembership,
  partnerOffers,
  profile,
  router,
  courseDetail,
  creditCards,
}) => ({
  ...networkMembership,
  userHasMembership: profile.hasNetworkMembership,
  courseId: courseDetail?.course?.id,
  creditCards: creditCards.creditCards,
  location: router?.location,
  vendors: partnerOffers.partnerVendors,
  isFetchingPartnerVendors: partnerOffers.isFetchingPartnerVendors,
  isFetchingPartnerVendorsDone: partnerOffers.isFetchingPartnerVendorsDone,
});

const mapDispatchToProps = {
  ...NetworkMembershipActions,
  ...PaymentMethodsActions,
  ...SearchParamsActions,
  ...TrackingActions,
  ...PartnerOffersActions,
};

export default connect(mapStateToProps, mapDispatchToProps);
